import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

import { SectionWrapper } from '../OnboardingV2/Onboarding.styled';

export const MetricsSectionWrapper = styled(SectionWrapper)`
	overflow: scroll;
	height: 82rem;
	padding: 0;
`;

export const SectionHeader = styled.div`
	padding: 1rem 2rem;
	position: sticky;
	top: 0;
	background-color: var(--white);
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: center;
	z-index: 1;

	& > .button {
		flex-shrink: 0;
		margin: 1rem 0;
	}
`;

export const Title = styled.div`
	display: flex;
	flex-direction: row;
	gap: 0.5rem;
	align-items: center;
	margin: 1rem 0;
`;

export const WidgetContainer = styled.div`
	padding: 0 2rem;

	& > div {
		margin-top: 0;
	}

	@media ${Breakpoints.tablet} {
		padding: 0 1rem;
	}
`;
